<script lang="ts" setup>
import { ref, Ref } from 'vue'
import { useDialogPluginComponent, Notify } from 'quasar'
import { GeneratedDocument } from '@/models/files/GeneratedDocument'
import { useApi } from '@/store/useAppStore'
import UserApi from '@/services/api/core/UserApi'
import BaseInput from '@/components/base/BaseInput.vue'
import BaseDialog from '@/components/base/BaseDialog.vue'

interface Props {
  fileType: string
}
const props = withDefaults(defineProps<Props>(), {})

const emit = defineEmits([...useDialogPluginComponent.emits])

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const userApi: UserApi = useApi()
const newDocumentName: Ref<string> = ref('')
const isLoading: Ref<boolean> = ref(false)

const inputLabel = 'Nom du nouveau document ' + props.fileType

async function renameFile() {
  try {
    isLoading.value = true
    emit('ok', {
      fileName: newDocumentName.value,
      fileType: props.fileType,
    })
  } catch (e) {
    dialogRef.value?.hide()
    isLoading.value = false
    // Notify.create({
    //   message: "Une erreur est survenue lors du renommage du document",
    //   type: "negative",
    // });
  }
}
</script>
<template>
  <q-dialog ref="dialogRef">
    <BaseDialog
      title="Nouveau document"
      :is-dialog-loading="isLoading"
      @on-dialog-cancel="onDialogCancel()"
      @hide="onDialogHide()"
    >
      <template #body>
        <BaseInput v-model="newDocumentName" type="text" :label="inputLabel"> </BaseInput>
      </template>
      <template #actions>
        <q-btn flat label="Créer" @click="renameFile()" color="primary" :disable="newDocumentName === ''" />
      </template>
    </BaseDialog>
  </q-dialog>
</template>
<style lang="scss" scoped></style>
